import { render, staticRenderFns } from "./UserInfo.vue?vue&type=template&id=22ce13a8&scoped=true"
import script from "./UserInfo.vue?vue&type=script&lang=js"
export * from "./UserInfo.vue?vue&type=script&lang=js"
import style0 from "./UserInfo.vue?vue&type=style&index=0&id=22ce13a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ce13a8",
  null
  
)

export default component.exports